import { Document } from 'services/document/document.types';

export const downloadFileAsBlob = async (file: Pick<Document, 'view_link' | 'label' | 'original_filename'>): Promise<void> => {
    if (!file.view_link) {
        throw new Error('No download link provided');
    }

    try {
        const response = await fetch(file.view_link, {
            headers: {
                'Content-Type': 'application/octet-stream'
            },
            cache: 'no-cache'
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.style.display = 'none'; // Cache le lien
        link.href = url;
        link.download = file.label || file.original_filename || 'document';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Libère la mémoire immédiatement
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
        console.error('Error downloading file:', error);
        throw new Error('Failed to download file');
    }
};
